export const EDIT_MODES = {
  VIEW: 'view',
  EDIT_LAYOUT: 'edit_layout',
};
